// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__ZKUMj","gfeWrapper":"CalendarEvent_gfeWrapper__3Dd9F"};